export default "__VITE_ASSET__DwOG46NS__"